export function viewStatus(data, status) {
  let newData = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];

    if (
      status.includes('ENABLED') &&
      element.status === 'NOT_RUNNING' &&
      element.enabled
    ) {
      newData.push(element);
      continue;
    }

    if (
      status.includes('DISABLED') &&
      element.status === 'NOT_RUNNING' &&
      !element.enabled
    ) {
      newData.push(element);
      continue;
    }

    if (status.includes(element.status)) {
      newData.push(element);
      continue;
    }
  }

  return [...newData];
}
